import { RandomId } from "@swivl-mono/helpers";
import { NodeInterface } from "@swivl-mono/types";

import TabNodeLayoutData from "../NodeLayouts/TabNodeLayoutData";
import InspectorFooter from "../SidePanel/Inspector/components/InspectorFooter";
import InspectorNodeHeader from "../SidePanel/Inspector/components/InspectorNodeHeader";
import NodePanel from "./NodePanel";

const Finish = {
  Type: "finish",
  Empty: function () {
    return {
      id: RandomId(6),
      type: Finish.Type
    };
  },

  PlumbData: function (node: NodeInterface) {
    return TabNodeLayoutData({
      node: node,
      title: "Finish",
      baseWidth: 90,
      bodyHeight: 14,
      tabs: []
    });
  },

  InspectorPanel: class FinishInspectorPanel extends NodePanel {
    render() {
      return (
        <div>
          <div className="panel start_panel">
            <InspectorNodeHeader title="Finish" />
          </div>
          <InspectorFooter
            deleteNode={this.deleteNode}
            node={this.props.node}
            duplicateNode={this.props.duplicateNode}
            canDuplicate={this.props.canDuplicate}
          />
        </div>
      );
    }
  }
};
export default Finish;
